import * as React from "react"

import * as SwitchPrimitive from "@radix-ui/react-switch"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../cn"

const switchVariants = cva([
  "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full",
  "border border-coval-border-control",
  "bg-surface-1",
  "transition-colors duration-150",
  "disabled:cursor-default disabled:opacity-50",
  "data-[state=checked]:bg-coval-contrast data-[state=checked]:border-coval-contrast",
])

const switchThumbVariants = cva([
  "pointer-events-none block size-3.5 rounded-full",
  "bg-coval-text-on-contrast",
  "shadow-sm",
  "transition-transform duration-150",
  "translate-x-0.5",
  "data-[state=checked]:translate-x-[1.125rem]",
  "data-[state=checked]:bg-coval-text-on-contrast",
])

export interface SwitchProps
  extends
    React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>,
    VariantProps<typeof switchVariants> {}

const Switch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitive.Root>,
  SwitchProps
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(switchVariants(), className)}
    {...props}
  >
    <SwitchPrimitive.Thumb className={cn(switchThumbVariants())} />
  </SwitchPrimitive.Root>
))
Switch.displayName = SwitchPrimitive.Root.displayName

export { Switch, switchVariants, switchThumbVariants }
